module.exports = __webpack_public_path__ + "img/iso9001.c275cc3d.png";